import { getSettings } from "./get-settings"

const settings = {
  getSettings,
}

export default settings
